// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"0e995227c5df81a12596","339":"d7aa3f1b78bee47b8cf0"}[chunkId] + ".js";
};